import { BankOperationStatusesNew } from 'constants/bankOperationStatusesNew';
import { Resources } from 'constants/resources';

import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';

import { useUpdateBankOperationsStatus } from './useUpdateBankOperationsStatus';

export function useChangeBankOperationStatus() {
  const { mutate: updateBankOperationsStatus } = useUpdateBankOperationsStatus();
  const notify = useNotify();
  const changeBankOperationStatus = (id: string, status: BankOperationStatusesNew) => {
    updateBankOperationsStatus(
      {
        id,
        data: {
          status,
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: [Resources.RequestBankOperations] });
          queryClient.invalidateQueries({
            queryKey: [`${Resources.RequestBankOperations}/available`, id],
          });
        },
        onError: (error: any) => notify(error?.data?.violations[0]?.message, { type: 'error' }),
      },
    );
  };
  return { changeBankOperationStatus };
}
